/*
 * hellopanda-overlay
 */
import { hellopanda_func as $ } from '../../../assets/script/func.js';
const HELLOPANDA_PROGRESS = {
  init: function() {
    const _ = this;
    document.addEventListener('DOMContentLoaded', function() {

      _.animation_init();

    });
  },
  animation_init: function() {
    const _ = this;

    const progress_array = document.querySelectorAll('.hellopanda-blocks-progress-animation');
    progress_array.forEach(progress_item => {

      const progress_container = progress_item.querySelector('.hellopanda-blocks-progress-container');
      const progress_type = progress_container.classList.contains('progress-circle') ? 'circle' : 'bar' ;
      const progress_line = progress_type === 'circle' ? 
                            progress_item.querySelector('circle + circle') : 
                            progress_item.querySelector('.hellopanda-blocks-progress-bar-front') ;
      if (progress_line) {

        const progress_class = $.randomOnlyString(10);
        const option_speed = progress_item.dataset.animeSpeed || '1';
        const option_delay = progress_item.dataset.animeDelay || '0';
        const option_spy = progress_item.dataset.animeSpy;
        const option_repeat = progress_item.dataset.animeRepeat;

        if (progress_type === 'circle') {
          _.animation_circle(progress_container, progress_line, progress_class, option_speed, option_delay, option_spy, option_repeat);
        } else {
          _.animation_bar(progress_container, progress_line, progress_class, option_speed, option_delay, option_spy, option_repeat);
        }

      }

    });
  },
  animation_circle: function(progress_container, progress_line, progress_class, option_speed, option_delay, option_spy, option_repeat) {
    const _ = this;

    const progress_max = progress_line.getAttribute('stroke-dashoffset');
    const progress_current = progress_line.getAttribute('stroke-dasharray');
    const progress_style = `
      <style>
        .${progress_class}${option_spy ? '.active' : ''} {
          stroke-dashoffset: ${option_spy ? progress_current : ''};
          animation: ${progress_class}-animation ${option_speed}s cubic-bezier(.25, .1, .25, 1) ${option_delay}s forwards;
        }
        @keyframes ${progress_class}-animation {
          from {
            stroke-dashoffset: ${progress_current};
          }
          to {
            stroke-dashoffset: ${progress_max};
          }
        }
      </style>
    `;
    progress_line.classList.add(option_spy ? 'animation' : 'ready');
    progress_line.classList.add(progress_class);
    progress_container.insertAdjacentHTML('beforeend', progress_style);

    // 옵저버 실행
    _.animation_observer(progress_container, progress_line, option_spy, option_repeat);

  },
  animation_bar: function(progress_container, progress_line, progress_class, option_speed, option_delay, option_spy, option_repeat) {
    const _ = this;

    const progress_width = progress_line.style.width;
    const progress_style = `
      <style>
        .${progress_class}${option_spy ? '.active' : ''} {
          white-space: nowrap;
          width: ${option_spy ? '0%' : ''};
          animation: ${progress_class}-animation ${option_speed}s cubic-bezier(.25, .1, .25, 1) ${option_delay}s forwards;
        }
        @keyframes ${progress_class}-animation {
          from {
            width: 0%;
          }
          to {
            width: ${progress_width};
          }
        }
      </style>
    `;
    progress_line.style.width = null;
    progress_line.classList.add(option_spy ? 'animation' : 'ready');
    progress_line.classList.add(progress_class);
    progress_container.insertAdjacentHTML('beforeend', progress_style);

    // 옵저버 실행
    _.animation_observer(progress_container, progress_line, option_spy, option_repeat);
  },
  animation_observer: function(progress_container, progress_line, option_spy, option_repeat) {

    // 옵저버 시작
    if (!option_spy) {
      return;
    }
    let observer;
    if (observer) {
      observer.disconnect();
    }

    const screen = option_spy === 'true' ? true : false ;
    const repeat = option_repeat === 'true' ? true : false ;

    observer = new IntersectionObserver(
      ([entry]) => {
        if (!screen && !repeat) {
          //
        } else if (screen && !repeat) {
          if (entry.isIntersecting) {
            progress_line.classList.add('active');
          }
        } else if (screen && repeat) {
          if (entry.isIntersecting) {
            progress_line.classList.add('active');
          } else {
            progress_line.classList.remove('active');
          }
        }

      },
      { 
        root: document,
        threshold: [0, 1],
        rootMargin: `0px 0px 0px 0px`,
        /* required options*/
        trackVisibility: true,
        delay: 100 // minimum 100
      }
    );

    // 옵저버 수행
    observer.observe(progress_container);

  }
};
HELLOPANDA_PROGRESS.init();